exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/**\n * Themings and color for POS app\n */\n.popup-message {\n  right: \"105px\";\n  color: #ffffff !important;\n  background-color: #4b8bb1 !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/pages/pointofsale/styles/components/popupMessage.less
// module id = 3154
// module chunks = 0